module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "kbx-content",
    attrs: {
      "klickbox-edit-item": "progress",
      "klickbox-edit-label": _vm.$t('edit.canvas.progressbar')
    }
  }, [_c('items')], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-43071f2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/progressbar/percent/Main.vue
 ** module id = 810
 ** module chunks = 1
 **/